import {createFileRoute} from '@tanstack/react-router';
import {CreditAccountCloseInfoPage} from '../../../../../../features/credit/pages/CreditAccountClosePage/CreditAccountCloseInfoPage';

export const Route = createFileRoute(
  '/_protected/accounts/credits/$accountId/close/',
)({
  component: CreditAccountCloseInfoPage,
});
